import React from 'react';
import { number } from 'prop-types';

const CopyIcon = ({ height = 24, width = 24 }) => {
  return (
    <svg data-test="iconarrowup" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1H4.5C3.4 1 2.5 1.9 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.4 5 6.5 5.9 6.5 7V21C6.5 22.1 7.4 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.9 20.6 5 19.5 5ZM8.5 21H19.5V7H8.5V21Z" fill="black" fill-opacity="0.54"/>
    </svg>
  );
};

CopyIcon.propTypes = {
  height: number,
  width: number
};

export default CopyIcon;